export const navigation = {
  AboutFullscript: "About Fullscript",
  AcceptableUsePolicy: "Acceptable Use Policy",
  AccessibilityPolicy: "Accessibility Policy",
  Blog: "Blog",
  BookADemo: "Book a demo",
  CaliPrivacyNotice: "California Privacy Notice",
  Careers: "Careers",
  Catalog: "Catalog",
  Collective: "Collective",
  CreateAnAccount: "Create an account",
  CreateAccount: "Create account",
  CultureGuide: "Culture guide",
  CustomerSupportPolicy: "Customer Support Policy",
  CCPA: "CCPA",
  DoNotSellMyInfo: "Do not sell my info",
  dashboard: "Dashboard",
  Education: "Education",
  EngineeringCulture: "Engineering culture",
  EasilyDispense: "Easily dispense professional-grade supplements through your EHR platform",
  GeneralFAQ: "General FAQ",
  HowItWorks: "How it works",
  IncorporateSupplements: "Easily incorporate supplements into your practice with Fullscript",
  IngredientLibrary: "Ingredient library",
  Integrations: "Integrations",
  Leadership: "Leadership",
  Learn: "Learn",
  Login: "Login",
  MenuItems: {
    PractitionerSoftware: "Practitioner software",
    ProductBody:
      "Write complete wellness plans, support treatment adherence, and dispense healthcare's best supplements — all in one place.",
    Pricing: "Pricing",
    Integrations: "Integrations",
    Patients: "Patients on Fullscript",
    BookADemo: "Book a demo",
    Spotlight: "Spotlight",
    WellnessBlog: "Wellness blog",
    PracticingVirtually: "Practicing virtually",
    Protocols: "Protocols",
    PracticeResources: "Practice resources",
    IngredientLibrary: "Ingredient library",
    Webinars: "Webinars",
    PractitionerSupport: "Practitioner support",
    PatientHelp: "Patient help",
    ChatWithUs: "Chat with us",
    ChatOnline: "Chat online",
    Product1: "Fullscript is $0/mo for everyone",
    Product2: "Use Fullscript in your EHR",
    Product3: "Learn about the patient experience",
    Product4: "See how Fullscript fits your practice",
    LearnMore: "Learn more",
    Learn1: "Fullscript updates, culture, and more.",
    Learn2: "Education for practitioners and patients.",
    Learn3: "Insights and advice for virtual practices.",
    Learn4: "Our library of evidence-based protocols.",
    Learn5: "Patient handouts, infographics, and more.",
    Learn6: "Patient handouts, infographics, and more.",
    Learn7: "+100 recordings of practitioner discussions.",
    Support1: "Questions about your account.",
    Support2: "Getting started and ongoing support",
    Support3: "Our world-class Customer Success Team is available for online support.",
  },
  News: "News",
  OurPlatform: "Our platform",
  Patients: "Patients",
  PatientShipping: "Patient shipping",
  PatientHelp: "Patient help",
  PatientTreatmentPlans:
    "Practitioners use Fullscript to dispense quality supplements and help maintain patient treatment plans",
  PracticeResources: "Practice resources",
  PracticingVirtually: "Practicing virtually",
  Practitioners: "Practitioners",
  PractitionerSoftware: "Practitioner software",
  PractitionerSupport: "Practitioner support",
  Pricing: "Pricing",
  Privacy: "Privacy",
  PrivacyStatement: "Privacy Statement",
  Protocols: "Protocols",
  ShopAllBrands: "Shop all brands",
  SignUpFree: "Sign up <2>FREE</2>",
  SignIn: "Sign in",
  SupplementQuality: "Supplement quality",
  Suppliers: "Suppliers",
  Support: "Support",
  Spotlight: "Spotlight",
  TreatmentAdherence: "Treatment adherence",
  TermsOfService: "Terms of Service",
  Testimonials: "Testimonials",
  TourThePlatform: "Tour the platform, Book a Fullscript demo with a member of our team today",
  VirtualDispensing: "Virtual dispensing",
  Webinars: "Webinars",
  Wholesale: "Wholesale",
  WholesaleShipping: "Wholesale shipping",

  // aria labels and alt text
  CloseNavigation: "Click to close navigation menu",
  EducationAria: "Education menu",
  HowItWorksAria: "How it works menu",
  OpenNavigation: "Click to open navigation menu",
  FullscriptLogo: "Click to go to Fullscript's homepage",

  // social media
  Facebook: "Facebook",
  Instagram: "Instagram",
  LinkedIn: "LinkedIn",
  Pinterest: "Pinterest",
  Twitter: "Twitter",
  YouTube: "YouTube",
} as const;
